import React from "react";
import { IconButton, TableCell } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { getSolicitudIconByEstado } from "../ListadoSolicitud.iconMaps";

// Columna "Solicitudes": ícono según idEstadoVerificacionSolicitud; navega al
// flujo de solicitud (Yupana o solicitudgrande según TipoFirmaElectronica).
export default function CeldaSolicitudes({
  data,
  isError,
  estaDeshabilitado,
  estadoDeshabilitadoporPermisos,
  handlesolicitud,
  handlePopoverOpen,
}) {
  return (
    <TableCell align="center">
      <div>

        <span>
          <IconButton
            onClick={() => handlesolicitud(data)}
            disabled={
              estaDeshabilitado(data) ||
              estadoDeshabilitadoporPermisos(data)
            }
            size="small"
            sx={{
              opacity: estaDeshabilitado(data) ? 0.4 : 1,
              bgcolor: isError ? "#fee2e2" : "#f1f5f9",
              "&:hover": {
                bgcolor: isError ? "#fca5a5" : "#e2e8f0",
                transform: "scale(1.1)",
              },
              transition: "all 0.2s ease",
            }}
          >
            {getSolicitudIconByEstado(
              data.idEstadoVerificacionSolicitud
            )}
          </IconButton>

          <span>
            <MoreVertIcon
              onClick={(event) =>
                handlePopoverOpen(event, 1, data)
              }
              style={{ cursor: "pointer" }}
              className="text-slate-400 hover:text-slate-600 transition-colors duration-200"
            />
          </span>
        </span>

      </div>
    </TableCell>
  );
}
